import React from 'react';
import Settings from './Settings';

export default class StorefrontCheckout extends React.PureComponent {
  render() {
    return <Settings {...this.props} params={{ section: 'checkout' }} />;
  }
}
